import { Component, Input, Output, EventEmitter, HostListener, OnInit, OnDestroy } from '@angular/core';

@Component({
	selector: 'bb-notice',
	templateUrl: './bb-notice.component.html',
	styleUrls: ['./bb-notice.component.scss']
})

export class BbNoticeComponent implements OnInit, OnDestroy {
	@Input() title: string;
	@Input() contents: string;
	@Input() type = 'warning';
	@Input() icon: string;
	@Input() showCopy = false;
	@Output() onConfirm = new EventEmitter();
	@Output() onCopy = new EventEmitter();

	confirmed = false;

	constructor() { }

	@HostListener('document:keyup', ['$event'])
	onKeyUp(ev: KeyboardEvent) {

		if (ev.key === 'Enter' || ev.key === 'Escape') {

			if (this.confirmed) {
				return; // ignore
			}

			this.confirm();
		}
	}

	ngOnInit() { }

	ngOnDestroy() { }

	confirm() {
		this.confirmed = true;
		this.onConfirm.emit();
	}

	copy() {
		this.onCopy.emit();
	}
}
